import React from 'react'

const ButtonOutline = ({children, transparent, outlineColor, className, style, onClick}) => {
  return (
    <button
      className={`${!transparent && 'bg-white'} rounded text-center p-2 w-full text-sm ${className}`}
      style={{
        borderColor: outlineColor === 'primary' ? '#DA251D' : '#999',
        ...style
      }}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export { ButtonOutline }